import './free_text_attribute_view.js.coffee'

class Customer.DecimalAttributeView extends Customer.FreeTextAttributeView
  valueTemplate: JST['backbone/templates/customer/custom_attributes/values/decimal']

  afterRender: ->
